module.exports = __webpack_public_path__ + "img/baseline-forward-24px.85ea9ec3.svg";